import { getSharedStyleSheet } from './sharedStyleSheet.js';

class UserAvatar extends HTMLElement {
    static observedAttributes = ['id', 'name', 'size'];

    constructor() {
        super();
    }

    attributeChangedCallback(attrName, oldValue, newValue) {
        this.dynamicRender();
    }

    connectedCallback() {
        if (!this.shadowRoot) {
            this.attachShadow({mode: 'open', delegatesFocus: true});

            this.shadowRoot.host.style.display = 'inline-block';

            // Share a single parsed stylesheet across all shadow roots
            getSharedStyleSheet().then(sheet => {
                this.shadowRoot.adoptedStyleSheets = [sheet];
            });

            this._wrapper = document.createElement('div');
            this._wrapper.className = 'avatar-wrapper';
            this.shadowRoot.appendChild(this._wrapper);

            this._avatar = document.createElement('div');
            this._avatar.className = 'avatar-image';
            this._wrapper.appendChild(this._avatar);

            this._name = document.createElement('div');
            this._name.className = 'avatar-name';
            this._wrapper.appendChild(this._name);
        }
        
        this.dynamicRender();
    }

    dynamicRender() {
        if (!this._wrapper || !this._avatar || !this._name) return;

        this._name.innerHTML = this.getAttribute('userName') ?? '';

        let imageURL = '../../../html/avatar?name=' + encodeURIComponent(this.getAttribute('userName') ?? '');

        if (!!this.getAttribute('avatarURL')) {
            imageURL = this.getAttribute('avatarURL');
        }

        this._avatar.style.backgroundImage = "url('" + imageURL + "')";

        this.classList.remove('small');
        this.classList.remove('mini');

        if (this.getAttribute('size')) {
            const size = this.getAttribute('size');
            this._wrapper.classList.add(size);
        }
    }
}

customElements.define('user-avatar', UserAvatar);

